import fetchCommerceToolsGraphQLApi from "../fetchCommerceToolsGraphQLApi"

import { Review as CommerceToolsReview } from "@secureo/common/typings/generated/commercetools-graphql"
import { Review } from "@secureo/common/typings/Product"

const limit = 30

const formatProductReview = (review: CommerceToolsReview) => {
	const { id, title, authorName, rating, text, custom } = review

	const isVerifiedPurchaser =
		custom?.customFieldsRaw?.find(({ name }) => name === "isVerifiedPurchaser")?.value ?? false
	const createdAt =
		custom?.customFieldsRaw?.find(({ name }) => name === "customDate")?.value ??
		review.createdAt

	const formattedReview: Review = {
		id,
		createdAt,
		title,
		authorName,
		rating: rating / 10,
		text,
		isVerifiedPurchaser,
	}

	return formattedReview
}

const fetchProductReviewsByProductId = async (accessToken: string, productId: string) => {
	const query = /* GraphQL */ `
		query reviews {
			reviews(where: "target(id=\\"${productId}\\")", limit: ${limit}) {
				results {
					id
					createdAt
					authorName
					rating
					title
					text
					custom {
						customFieldsRaw(includeNames: ["isVerifiedPurchaser", "customDate"]) {
							name
							value
						}
					}
				}
			}
		}
	`

	const data = (await fetchCommerceToolsGraphQLApi(accessToken, query)) as {
		reviews: {
			results: CommerceToolsReview[]
		}
	}

	const reviews = data?.reviews?.results ?? []

	const formattedReviews = reviews.map(formatProductReview)
	const sortedReviews = formattedReviews.sort((a, b) => a.createdAt.localeCompare(b.createdAt))

	return sortedReviews
}

export default fetchProductReviewsByProductId
